import React from "react";

const UnibtcIcon: React.FC = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity="0.8">
      <path
        d="M16.0165 5.95L15.6965 5.87V5.86C15.6865 5.86 15.6565 5.85 15.6565 5.85L14.1765 5.48L14.8565 2.81L16.6965 3.28L16.0165 5.95Z"
        fill="black"
      />
      <path
        d="M10.1143 21.5313L10.7889 18.8653L12.6308 19.3314L11.9562 21.9974L10.1143 21.5313Z"
        fill="black"
      />
    </g>
    <g opacity="0.6">
      <path
        d="M13.8165 13.1H13.8265L10.9965 12.4L10.7065 13.53L14.7365 14.55C15.5465 14.76 16.0465 15.54 15.8665 16.3C15.6765 17.06 14.8665 17.51 14.0565 17.3L10.0165 16.28L9.44653 18.54L10.7865 18.88L12.6265 19.34L13.4865 19.57H13.4765C15.6165 20.11 17.7665 18.91 18.2765 16.92C18.6765 15.36 17.9265 13.76 16.5565 12.87C15.7365 13.25 14.7765 13.37 13.8065 13.12L13.8165 13.1Z"
        fill="black"
      />
      <path
        d="M4.57157 14.8839L4 17.1427L6.35575 17.7388L6.92732 15.48L4.57157 14.8839Z"
        fill="black"
      />
    </g>
    <g opacity="0.2">
      <path
        d="M6.79541 6.01658L7.36579 3.75747L9.72186 4.35233L9.15147 6.61144L6.79541 6.01658Z"
        fill="black"
      />
      <path
        d="M18.6266 10.46C19.1366 8.48 17.8166 6.43 15.6966 5.87C15.6934 5.86894 15.6661 5.86006 15.6566 5.86L14.1766 5.49L12.8378 5.15282L12.8416 5.13804L12.8222 5.13313L12.2502 7.39184L12.2696 7.39675L12.3546 7.06123L12.2666 7.41L15.0866 8.12C15.8966 8.33 16.3966 9.11 16.2166 9.87C16.0266 10.63 15.2166 11.08 14.4066 10.87L11.5866 10.16L11.3032 11.2642L11.2889 11.2606L11.5765 10.14L8.47649 9.36L7.90649 11.62L9.09649 11.92L9.30579 11.1045L9.09912 11.9218L11.009 12.4047L11.0094 12.4032L13.8266 13.11H13.8166C14.778 13.3479 15.7296 13.2223 16.5448 12.85L16.5766 12.87C17.5666 12.41 18.3566 11.57 18.6366 10.48L18.6266 10.46Z"
        fill="black"
      />
    </g>
    <path
      d="M11.009 4.67301L11.6865 1.99746L13.5284 2.46386L12.8509 5.13942L11.009 4.67301Z"
      fill="black"
    />
    <path
      d="M6.92871 20.7279L7.60085 18.0716L9.4428 18.5377L8.77066 21.194L6.92871 20.7279Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7163 13.53L11.0005 12.4061L9.10028 11.9257L8.84227 12.9461L9.09651 11.92L7.90651 11.62L6.92651 15.48L6.35789 17.7353L6.35281 17.734L6.35034 17.7437L7.60669 18.0634V18.07L9.44669 18.53V18.52L9.45669 18.52L10.0267 16.27L10.7163 13.53ZM9.44669 18.52L7.611 18.0611L7.61264 18.0546L7.60669 18.0531V18.05L9.44669 18.52Z"
      fill="black"
    />
    <path
      d="M12.2566 7.4H12.2666L11.5766 10.14L8.47656 9.36L9.09555 6.924L9.08618 6.92163L9.08032 6.91952L9.15637 6.61899L12.2451 7.40063L12.1699 7.6983L12.1766 7.7L12.2566 7.4Z"
      fill="black"
    />
    <path
      d="M12.8265 5.14L11.8348 4.89047L12.8224 5.14018L12.2512 7.39909L9.16821 6.61955L9.73877 4.36309L9.7359 4.36236L9.73649 4.36L12.8265 5.14Z"
      fill="black"
    />
    <path
      d="M9.7359 4.36236L9.16649 6.62L9.15649 6.61L9.72649 4.36L9.7359 4.36236Z"
      fill="black"
    />
  </svg>
);

export default UnibtcIcon;
